import { render, staticRenderFns } from "./headResume.vue?vue&type=template&id=492c4ef2&scoped=true&"
import script from "./headResume.vue?vue&type=script&lang=js&"
export * from "./headResume.vue?vue&type=script&lang=js&"
import style0 from "./headResume.vue?vue&type=style&index=0&id=492c4ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c4ef2",
  null
  
)

export default component.exports